module.exports = __webpack_public_path__ + "img/horizontal_7_1_9006.c0abec2f.png";